import { useState } from "react";
import { supabase } from "./supabaseClient";

const RED = "#D20A11";
const BLUE = "#003A8F";
const DARK = "#0d0d0d";

export default function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [mode, setMode] = useState("login");

  const handleLogin = async () => {
    if (!email || !password) { setError("Bitte E-Mail und Passwort eingeben."); return; }
    setLoading(true); setError("");
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError("Login fehlgeschlagen. Bitte prüfe deine Zugangsdaten.");
    else onLogin(data.user);
    setLoading(false);
  };

  const handleForgot = async () => {
    if (!email) { setError("Bitte E-Mail eingeben."); return; }
    setLoading(true); setError("");
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "?reset=true",
    });
    if (error) setError(`Fehler: ${error.message}`);
    else setMode("forgot_sent");
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: DARK, display: "flex", flexDirection: "column", fontFamily: "'Arial Black', Arial, sans-serif", overflowX: "hidden" }}>
      <div style={{ position: "relative", height: 200, overflow: "hidden", flexShrink: 0 }}>
        <div style={{ position: "absolute", inset: 0, background: RED }} />
        <div style={{ position: "absolute", inset: 0, background: BLUE, clipPath: "polygon(52% 0, 100% 0, 100% 100%, 42% 100%)" }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(105deg, transparent 46%, rgba(255,255,255,0.12) 47%, rgba(255,255,255,0.12) 49%, transparent 50%)" }} />
        <div style={{ position: "absolute", top: "42%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 10 }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 10, letterSpacing: 4, color: "rgba(255,255,255,0.7)", textTransform: "uppercase", marginBottom: 6 }}>FC Basel 1893</div>
            <div style={{ fontSize: 28, fontWeight: 900, color: "#fff", letterSpacing: 3, textTransform: "uppercase" }}>PRO-TRACK</div>
            <div style={{ width: 40, height: 3, background: RED, margin: "8px auto" }} />
            <div style={{ fontSize: 9, color: "rgba(255,255,255,0.5)", letterSpacing: 3, textTransform: "uppercase" }}>Mental Performance · </div>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 24px" }}>
        <div style={{ width: "100%", maxWidth: 380 }}>

          {mode === "forgot_sent" ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 40, marginBottom: 16, color: RED }}>✓</div>
              <div style={{ fontSize: 16, fontWeight: 900, color: "#fff", textTransform: "uppercase", letterSpacing: 2, marginBottom: 12 }}>E-Mail gesendet</div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 28, fontFamily: "Georgia, serif", lineHeight: 1.7 }}>Prüfe dein Postfach. Du erhältst einen Link zum Passwort zurücksetzen.</div>
              <button onClick={() => setMode("login")} style={{ background: RED, border: "none", borderRadius: 8, color: "#fff", padding: "13px 28px", fontSize: 11, fontWeight: 900, cursor: "pointer", letterSpacing: 2, textTransform: "uppercase" }}>← Zurück zum Login</button>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: 28, borderLeft: `3px solid ${RED}`, paddingLeft: 14 }}>
                <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", letterSpacing: 3, textTransform: "uppercase", marginBottom: 4, fontFamily: "sans-serif" }}>{mode === "login" ? "Anmelden" : "Passwort vergessen"}</div>
                <div style={{ fontSize: 20, fontWeight: 900, color: "#fff", textTransform: "uppercase", letterSpacing: 1 }}>{mode === "login" ? "Willkommen zurück" : "Passwort zurücksetzen"}</div>
              </div>

              {error && <div style={{ background: `${RED}22`, border: `1px solid ${RED}`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#fff", fontFamily: "sans-serif" }}>{error}</div>}

              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 6, fontWeight: 700, fontFamily: "sans-serif" }}>E-Mail</div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && (mode === "login" ? handleLogin() : handleForgot())} placeholder="deine@email.com"
                  style={{ width: "100%", padding: "13px 14px", borderRadius: 8, background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", color: "#fff", fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "sans-serif" }} />
              </div>

              {mode === "login" && (
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 6, fontWeight: 700, fontFamily: "sans-serif" }}>Passwort</div>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} placeholder="••••••••"
                    style={{ width: "100%", padding: "13px 14px", borderRadius: 8, background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", color: "#fff", fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "sans-serif" }} />
                </div>
              )}

              {mode === "login" && (
                <div style={{ textAlign: "right", marginBottom: 24 }}>
                  <button onClick={() => { setMode("forgot"); setError(""); }} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.35)", fontSize: 11, cursor: "pointer", fontFamily: "sans-serif", letterSpacing: 1 }}>Passwort vergessen?</button>
                </div>
              )}

              {mode === "forgot" && <div style={{ marginBottom: 24 }} />}

              <button onClick={mode === "login" ? handleLogin : handleForgot} disabled={loading} style={{ width: "100%", padding: "15px", background: loading ? `${RED}80` : RED, border: "none", borderRadius: 8, color: "#fff", fontSize: 11, fontWeight: 900, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 3, textTransform: "uppercase" }}>
                {loading ? "..." : mode === "login" ? "Einloggen →" : "Link senden →"}
              </button>

              {mode === "forgot" && (
                <button onClick={() => { setMode("login"); setError(""); }} style={{ width: "100%", padding: "12px", marginTop: 10, background: "transparent", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "rgba(255,255,255,0.4)", fontSize: 11, cursor: "pointer", letterSpacing: 2, textTransform: "uppercase", fontFamily: "sans-serif" }}>← Zurück</button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
